import React, { useState } from "react";
import styles from "./IngredientsMaterial.module.css";
import TopTabComponent from "../../../../../components/TopTabComponent/TopTabComponent";
import {
  Dropdown,
  Modal,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import { Table } from "antd";
import { IoMdCloseCircle, IoMdStar } from "react-icons/io";
import editIcon from "../../../../../assets/images/editIcon.png";
import crossIcon from "../../../../../assets/images/crossIcon.png";
import starIcon from "../../../../../assets/images/starIcon.png";
import { ReactComponent as StarSvg } from "../../../../../assets/images/starIcon.svg";
import HeadingComponent from "../../../../../components/HeadingComponent/HeadingComponent";
import { SearchOutlined } from "@ant-design/icons";
import { IoClose } from "react-icons/io5";
import MultipleCheck from "../../../../../components/MultipleCheck/MultipleCheck";
import { useNavigate } from "react-router-dom";
const IndredientsMaterial = () => {
 
  const navigate= useNavigate();

  const options = [
    { id: 1, name: "Ingredient" },
    { id: 2, name: "Components" },
    { id: 3, name: "Materials" },
  ];
  const [focused, setFocused] = useState(options[0]);
  const [addIngredients, setAddIngredients] = useState(false);
  const [editIngredients, setEditIngredients] = useState(false);
    const [completeModal, setCompleteModal] = useState(false);
    const [scalingStation, setScalingStation] = useState({
                value: "Scaling Station",
                id: 1,

    });

  const [modalArr, setModalArr] = useState([
    "Flour, AP KA",
    "Flour, Rogers 500",
    "Milk, 2%",
    "Flour, 7 grain cereal",
  ]);

  console.log("modallllll", modalArr);

const MachineUsedByOptions = [
  { id: 1, name: "Levain" },
  { id: 2, name: "Starter" },
  { id: 3, name: "Poolish" },
  { id: 4, name: "Soaker" },
  { id: 5, name: "Biga" },
  { id: 6, name: "Yudane" },
  { id: 7, name: "Tangzhong" },
  { id: 8, name: "Scald" },
];



  const columns = [
    {
      // title: "Ingredients",
       title:
      focused?.id === 1
        ? "Ingredients"
        : focused?.id === 2
        ? "Component"
        : "Materials",
      dataIndex: "ingredients",
      key: "ingredients",
      width: "49%",
      render: (i, item, num) => (
        // console.log(item),
        <div className={styles.ingredientsCont}>
          <div className={styles.indgTextDiv}>
            <TextComponent
              className={styles.indgText}
              text={item?.ingredients}
            />
          </div>
          <div className={styles.iconsCont}>
            <img
              src={crossIcon}
              style={{
                width: "20px",
                height: "20px",
                marginRight: "10px",
                cursor: "pointer",
              }}
            />
            <img
              src={editIcon}
              style={{
                width: "20px",
                height: "20px",
                marginRight: "10px",
                cursor: "pointer",
              }}
onClick={() => {
          setEditIngredients(true);
        }}
            />
            {item?.star ? (
              <StarSvg width={20} height={20} />
            ) : (
              <img
                src={starIcon}
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
              />
            )}
          </div>
        </div>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "name",
      width: "24%",
      align: "center",

      render: (text, record) => (
        <div className={styles.Quantitydiv}>
          <TextComponent className={styles.materialText} text={text} />
          <img
            src={editIcon}
            style={{
              width: "20px",
              height: "20px",
              marginLeft: "10px",
              cursor: "pointer",
            }}
          />
        </div>
      ),
    },
    {
      title: "Total Baker's",
      dataIndex: "total_bakers",
      key: "total_bakers",
      width: "24%",
      align: "center",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
  ];

  const data = [
    {
      id: 1,
      ingredients: "Flour, AP KA",
      quantity: "100.00",
      total_bakers: "100",
      star: true,
    },
    {
      id: 2,
      ingredients: "Baking Soda",
      quantity: "0.81",
      total_bakers: "0.81",
      star: false,
    },
    {
      id: 3,
      ingredients: "Sea Salt, fine",
      quantity: "1.71",
      total_bakers: "1.71",
      star: false,
    },
    {
      id: 4,
      ingredients: "butter, unsalted",
      quantity: "47.62",
      total_bakers: "47.62",
      star: true,
    },
    {
      id: 5,
      ingredients: "butter, unsalted",
      quantity: "100.00",
      total_bakers: "100",
      star: false,
    },
    {
      id: 6,
      ingredients: "Flour, AP KA",
      quantity: "100.00",
      total_bakers: "100",
      star: true,
    },
    {
      id: 7,
      ingredients: "Flour, AP KA",
      quantity: "100.00",
      total_bakers: "100",
      star: false,
    },
  ];
  return (
    <div style={{ height: "100vh" }}>
      <div className={styles.tabCont}>
        <TopTabComponent
          options={options}
          focused={focused}
          setFocused={setFocused}
          TabStyle={styles.TabStyle}
          TabLabelColor={"--var(--white-color)"}
        />
      </div>
      <div className={styles.filterHeader}>
        <div className={styles.filterHeaderLeft}>
          <Dropdown
            inputClass={styles.textColor}
            className={styles.filterInput}
            value={scalingStation}
            // inputStyle={{
            //   backgroundColor: "var(--primary-color)",
            //   color: "var(--white-color)",
            // }}
            labelStyle={{ fontSize: 18  ,  color: "white"}}
            style={{ color: "white" }}
             options={[
              {
                value: "Scaling Station",
                id: 1,
              },
              { value: "Mixing", id: 1 },
              { value: "Oven", id: 2 },
              { value: "Proof", id: 3 },
              { value: "Chill", id: 4 },
              { value: "Assembly", id: 5 },
              { value: "Packaging", id: 6 },
              { value: "Make Up", id: 7 },
           
            ]}
          onChange={(e) => setScalingStation( "station", e)}
          />
        
          {focused?.id == 1 && (
    <MultipleCheck label={"Pre-Ferments"} data={MachineUsedByOptions} displayCheckBox rangePickerInput={styles.rangePickerInput} rangePickerText={styles.rangePickerText} />
            
            // <Dropdown
            //   inputClass={styles.textColor}
            //   className={styles.filterInput}
            //   // value={station.station}
            //   // inputStyle={{
            //   //   backgroundColor: "var(--primary-color)",
            //   //   color: "white",
            //   // }}
            //   labelStyle={{ fontSize: 18 }}
            //   style={{ color: "white" }}
            //   options={[
            //     {
            //       value: "Add Pre-Ferments",
            //       id: 1,
            //     },
            //     {
            //       value: "Filling",
            //       id: 2,
            //     },
            //   ]}
            // // onChange={(e) => updateStation(index, "station", e)}
            // />
          )}

            <SubmitButton
            title={
              focused?.id == 1
                ? "Add Ingredients"
                : focused?.id == 2
                  ? "Add Component"
                  : "Add Materials"
            }
            primary
            btnContainerClass={styles.filteerBtn}
            onClick={
              // focused?.id == 1
              //   ? 
              () => {
                setAddIngredients(true);
              }
              // : null
            }
          />
        </div>
        <div className={styles.filterHeaderRight}>
          <SubmitButton
            title={"Save & Proceed"}
            primary
            btnContainerClass={styles.filterRightBtn}
             onClick={ () => {
              // navigate("Warehouse/ComponentMGMT");
              setCompleteModal(true); }}
          />
        </div>
      </div>
      <Table
        scroll={{ x: true }}
        columns={columns}
        dataSource={data}
        pagination={false}
        rowKey="No"
        rowClassName={styles.tableRow}
        footer={() => (
          <div className={styles.tableFooter}>
            <div className={styles.footerRow}>
              <div className={styles.footerLabel}>
                <TextComponent
                  text={"Total Quantity"}
                  className={styles.footerText}
                />
              </div>
              <div className={styles.footerValue}>
                <TextComponent text={"332.36"} className={styles.footerText} />
              </div>
              <div className={styles.footerValue}>
                <TextComponent text={"332.36"} className={styles.footerText} />
              </div>
            </div>
            {/* <div className={styles.footerRow}>
              <div className={styles.footerLabel}>
                <TextComponent
                  text={"Total Cost"}
                  className={styles.footerText}
                />
              </div>
              <div className={styles.footerValue}></div>
              <div className={styles.footerValue}>
                <TextComponent text={"$332.36"} className={styles.footerText} />
              </div>
            </div> */}
          </div>
        )}
      />
      <Modal
        subClassName={styles.modalContentStyle}
        open={addIngredients}
        onCancel={() => {
          setAddIngredients(false);
        }}
        onClickOkButton={() => {
          setAddIngredients(false);
        }}
        className={styles.Modal}
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        // width={"90%"}
        twoButton
        onBtnPress={() => setAddIngredients(false)}
        title={`Add ${focused?.name}`}
      >
        {/* <HeadingComponent
          text={`Add ${focused?.name}`}
          fontSize={25}
        // textAlign={"left"}
        /> */}
        <SearchInput
          rightIcon={<SearchOutlined />}
          placeholder={"Search Ingredients"}
        />
        <div className={styles.modalArrDiv}>
          {modalArr?.map((item, index) => (
            <div className={styles.modalArrItem}>
              <TextComponent text={item} />
              <IoClose size={20} style={{ cursor: "pointer" }} onClick={() => {
                let arr = [...modalArr];
                const result = arr.filter((_, i) => i !== index);
                setModalArr(result)
              }} />
            </div>
          ))}
        </div>
      </Modal>

 <Modal
        subClassName={styles.modalContentStyle}
        open={editIngredients}
        onCancel={() => {
          setEditIngredients(false);
        }}
        onClickOkButton={() => {
          setEditIngredients(false);
        }}
        className={styles.Modal}
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        // width={"90%"}
        twoButton
        onBtnPress={() => setEditIngredients(false)}
        title={`Edit ${focused?.name}`}
      >
        {/* <HeadingComponent
          text={`Add ${focused?.name}`}
          fontSize={25}
        // textAlign={"left"}
        /> */}
        <SearchInput
          rightIcon={<SearchOutlined />}
          placeholder={"Search Ingredients"}
        />
        <div className={styles.modalArrDiv}>
          {modalArr?.map((item, index) => (
            <div className={styles.modalArrItem}>
              <TextComponent text={item} />
              <IoClose size={20} style={{ cursor: "pointer" }} onClick={() => {
                let arr = [...modalArr];
                const result = arr.filter((_, i) => i !== index);
                setModalArr(result)
              }} />
            </div>
          ))}
        </div>
      </Modal>

      <Modal

        open={completeModal}
        onCancel={() => {
          setCompleteModal(false);
        }}
        onClickCancelButton={() => {
          setCompleteModal(false);
        }}
        onClickOkButton={() => {
          setCompleteModal(false);
              navigate("/Warehouse/ComponentMGMT");
        }}
        className={styles.Modal}
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        title={"Save and Proceed"}
        twoButton

      >

      </Modal>
    </div>
  );
};

export default IndredientsMaterial;
